





















import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import {GetShiftList, GetWardList} from "@/api/specialDictionary"
import {GetConForecast} from "@/api/dialysisProcess"

@Component({
	components: {}
})
export default class Temp extends AbpBase {
	query = {
		WardId: '0',
		Date: new Date(),
		ShiftId: '0',
		QueryString: ''
	}
	options = {
		disabledDate(date: any) {
			return date && date.valueOf() < Date.now() - 86400000;
		}
	}
	tableData1 = []
	tableData2 = []
	tableLoading = true
	wards: any = []
	shiftList: any = []
	columns1: any = [
		{
			title: "病区",
			key: 'wardName',
			align: 'center',
			width: 130,
		}, {
			title: '透析模式',
			align: 'center',
			render: (h: any, p: any) => {
				let arr: any = []
				if (p.row.dialysisWayItems) {
					p.row.dialysisWayItems.forEach((item: any) => {
						arr.push(h('div', item.statistics))
					})
				}
				return h('div', arr)
			}
		}, {
			title: '透析液',
			align: 'center',
			render: (h: any, p: any) => {
				let arr: any = []
				if (p.row.dialysisItems)
					p.row.dialysisItems.forEach((item: any) => {
						arr.push(h('div', item.statistics))
					})
				return h('div', arr)
			}
		}, {
			title: '灌流器',
			align: 'center',
			render: (h: any, p: any) => {
				let arr: any = []

					p.row.hemoditoxifierItems.forEach((item: any) => {
						arr.push(h('div', item.statistics))
					})
				return h('div', arr)
			}
		}, {
			title: '透析器',
			align: 'center',
			render: (h: any, p: any) => {
				let arr: any = []
				if (p.row.dialyzerItems)
					p.row.dialyzerItems.forEach((item: any) => {
						arr.push(h('div', item.statistics))
					})
				return h('div', arr)
			}
		}, {
			title: '延长管',
			align: 'center',
			render: (h: any, p: any) => {
				let arr: any = []
				if (p.row.tubeItems)
					p.row.tubeItems.forEach((item: any) => {
						arr.push(h('div', item.statistics))
					})
				return h('div', arr)
			}
		}, {
			title: '内瘘针',
			align: 'center',
			render: (h: any, p: any) => {
				let arr: any = []
				if (p.row.ifnItems)
					p.row.ifnItems.forEach((item: any) => {
						arr.push(h('div', item.statistics))
					})
				return h('div', arr)
			}
		}, {
			title: '血管通路',
			align: 'center',
			render: (h: any, p: any) => {
				let arr: any = []
				if (p.row.vaItems)
					p.row.vaItems.forEach((item: any) => {
						arr.push(h('div', item.statistics))
					})
				return h('div', arr)
			}
		}
	]
	columns2: any = [
		{
			title: "序号",
			align: 'center',
			render: (h: any, p: any) => {
				return h('span', p.index + 1)
			}
		}, {
			title: "患者姓名",
			align: 'center',
			key: 'patientName'
		}, {
			title: "病区",
			align: 'center',
			key: 'wardName'
		}, {
			title: "床号",
			align: 'center',
			key: 'bedCode'
		}, {
			title: "透析模式",
			align: 'center',
			key: 'dialysisWay'
		}, {
			title: "透析液",
			align: 'center',
			key: 'dialysis'
		}, {
			title: "灌流器",
			align: 'center',
			key: 'hemoditoxifier'
		}, {
			title: "透析器信息",
			align: 'center',
			key: 'dialyzer'
		}, {
			title: "延长管信息",
			align: 'center',
			key: 'tube'
		}, {
			title: "内瘘针信息",
			align: 'center',
			key: 'ifn'
		}, {
			title: "血管通路",
			align: 'center',
			key: 'va'
		}
	]

	get cardHeight() {
		return window.innerHeight - 200
	}

	created() {
		this.getSelects()
		this.getData()
	}

	async getSelects() {
		let res = await GetWardList({
			SkipCount: 1,
			MaxResultCount: 10000
		})
		this.wards = res.items
		let data = {
			QueryString: '',
			SkipCount: 1,
			MaxResultCount: 10000
		}
		let res1 = await GetShiftList(data)
		this.shiftList = res1.items
	}

	async getData() {
		this.tableLoading = true
		let query:any = {
			WardId: this.query.WardId,
			Date: this.formatDate(this.query.Date),
			ShiftId: this.query.ShiftId,
		}
		if (this.query.QueryString) {
			query.QueryString = this.query.QueryString
		}
		let res = await GetConForecast(query)
		this.tableData1 = res.objects.totalCons
		this.tableData2 = res.objects.patCons
		this.tableLoading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/treatRoomManage/preCheck/index.vue